import { WalletCard } from '@basqet-dashboard/common/components';
import { useFetchPayoutWallets } from '@hooks/queries';
import PropTypes from 'prop-types';
import React from 'react';

const SelectedWallet = ({ label, currencyId }) => {
  const { wallets } = useFetchPayoutWallets();

  const selectedWallet = wallets.find(
    (wallet) => parseInt(wallet.currency_id) === parseInt(currencyId)
  );

  return selectedWallet ? (
    <>
      <p className="form__label">{label}</p>
      <WalletCard wallet={selectedWallet} />{' '}
    </>
  ) : (
    <></>
  );
};

SelectedWallet.propTypes = {
  label: PropTypes.string,
  currencyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export { SelectedWallet };
